import { render, staticRenderFns } from "./aaLockCardRecord.vue?vue&type=template&id=5484e564&"
import script from "./aaLockCardRecord.vue?vue&type=script&lang=js&"
export * from "./aaLockCardRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports